import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const services = [
  { name: "Software Development", slug: "software-development", description: "Build scalable, efficient, and secure software solutions." },
  { name: "Digital Transformation", slug: "digital-transformation", description: "Modernize your business with cutting-edge technology." },
  { name: "Cloud Services", slug: "cloud-services", description: "Seamlessly migrate and optimize your IT infrastructure." },
  { name: "AI & Machine Learning", slug: "ai-machine-learning", description: "Turn data into insights and intelligent automation." },
  { name: "Data Engineering", slug: "data-engineering", description: "Build robust data pipelines and analytics platforms." },
  { name: "Managed Services", slug: "managed-services", description: "Let us handle your technology operations." },
];

export function ServicesSection() {
  return (
    <section data-testid="services-section" className="bg-slate-50 py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-4">
            What We Do
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 font-['Outfit']">
            Our Services
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
          {services.map((service) => (
            <Link 
              key={service.slug}
              to={`/services/${service.slug}`}
              className="service-card bg-white p-8 border border-slate-200 group"
            >
              <h3 className="text-xl font-semibold text-slate-900 font-['Outfit'] mb-3 group-hover:text-blue-700 transition-colors">
                {service.name}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed font-['Plus_Jakarta_Sans'] mb-4">
                {service.description}
              </p>
              <span className="inline-flex items-center text-blue-600 text-sm font-medium">
                Learn more
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
        
        <div className="mt-10 text-center">
          <Link to="/services">
            <Button 
              variant="outline"
              className="border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white rounded-none px-8"
            >
              View All Services
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
